<div class="page-header">
    <button (click)="setPageNumber(1)" [disabled]="pageIn.pageNumber === 1" class="btn btn-default color-blue" aria-label="İlk Sayfa" i18n-title="İlk Sayfa" title="İlk Sayfa">
        <fa-icon [icon]="faAngleDoubleLeft" aria-hidden="true"></fa-icon>
    </button>
    <button (click)="setPageNumber(pageIn.pageNumber-1)" [disabled]="pageIn.pageNumber === 1" class="btn btn-default color-blue" aria-label="Geri" i18n-title="Geri" title="Geri">
        <fa-icon [icon]="faAngleLeft" aria-hidden="true"></fa-icon>
    </button>
    <span class="btn-default text-faded page-number">
        {{ pageIn.pageNumber }} / {{ pageIn.totalPages }}      
    </span>
    <button (click)="setPageNumber(pageIn.pageNumber+1)" [disabled]="pageIn.pageNumber >= pageIn.totalPages" class="btn btn-default color-blue" aria-label="İleri" i18n-title="İleri" title="İleri">
        <fa-icon [icon]="faAngleRight" aria-hidden="true"></fa-icon>
    </button>
    <button (click)="setPageNumber(pageIn.totalPages)" [disabled]="pageIn.pageNumber >=pageIn.totalPages" class="btn btn-default color-blue" aria-label="Son Sayfa" i18n-title="Son Sayfa" title="Son Sayfa">
        <fa-icon [icon]="faAngleDoubleRight" aria-hidden="true"></fa-icon>
    </button>
</div>
